import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded'
import { keyframes } from '@mui/system'

// PAYPER-1181: el reloj de arena se voltea mientras se reintenta la petición,
// para que haya movimiento en pantalla durante la espera.
const FLIP_DURATION_S = 2.4
const flip = keyframes`
  0%, 40% { transform: rotate(0deg); }
  50%, 90% { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
`

// PAYPER-1177: parpadeo suave de la frase rotativa. Dura medio ciclo del reloj
// (un volteo) y ambas animaciones arrancan al montarse, así que cada iteración
// termina justo al acabar un volteo: ahí cambiamos de frase, en el punto de
// menor opacidad.
const pulse = keyframes`
  0% { opacity: 0.35; }
  30%, 70% { opacity: 1; }
  100% { opacity: 0.35; }
`

const randomIndex = (length: number, exclude?: number) => {
  if (length < 2) return 0
  const index = Math.floor(Math.random() * (length - 1))
  return exclude !== undefined && index >= exclude ? index + 1 : index
}

// PAYPER-1123: estado "en proceso" (back devuelve 202). Deliberadamente NO
// reutiliza el spinner de carga inicial ni el icono de Error: usa un icono de
// aviso propio (reloj de arena) para no confundirse con ninguno de los otros
// dos estados; en el mismo amarillo de marca que el resto de la barra
// (primary.main). Icono en caja redondeada como en Error.
// PAYPER-1177: sin título ni subtítulo, solo la frase rotativa bajo el reloj.
const Generating = ({
  phrases = [],
  height = 300,
  width = '100%',
}: {
  phrases?: string[]
  height?: number | string
  width?: number | string
}) => {
  const [phraseIndex, setPhraseIndex] = useState(() =>
    randomIndex(phrases.length)
  )

  return (
    <Box
      sx={{
        height,
        width,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        rowGap: 'var(--spacing-m)',
        p: 2,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '4em',
          height: '4em',
          borderRadius: 'var(--corners-l)',
          backgroundColor: 'warning.light',
          color: 'primary.main',
        }}
      >
        <HourglassTopRoundedIcon
          sx={{
            fontSize: '1.75em',
            animation: `${flip} ${FLIP_DURATION_S}s ease-in-out infinite`,
            '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
          }}
        />
      </Box>
      {phrases.length > 0 && (
        <Typography
          noWrap
          onAnimationIteration={() =>
            setPhraseIndex((prev) => randomIndex(phrases.length, prev))
          }
          sx={{
            color: 'neutral.dark',
            fontSize: { xs: '0.875em', sm: '1em' },
            lineHeight: 1.5,
            minHeight: '1.5em',
            maxWidth: '100%',
            animation: `${pulse} ${FLIP_DURATION_S / 2}s ease-in-out infinite`,
            '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
          }}
        >
          {phrases[phraseIndex]}
        </Typography>
      )}
    </Box>
  )
}

export default Generating
